import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useEffect, useState } from "react";
import { MediaUrl } from "../utils/media/Media";
import CGU from "./CGU.md";
import CGV from "./CGV.md";
import { useFetch } from "../api/FetchApiData";
import { BrowserView, isMobile } from "react-device-detect";
import DivLoader from "../utils/Loaders/DivLoader";

if (isMobile)
    import('./cgu_mob.css').then(() => {}).then(() => {});
else
    import('./cg.css').then(() => {}).then(() => {});

export default function CG({close=()=>{},display_close_button=true}) {
  const [content, setContent] = useState("");
  const [headings, setHeadings] = useState([]);
  const fetch_data = useFetch();

  const slugify = (text) =>
  text
    .toLowerCase()
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // enlève accents
    .replace(/[^\w\s-]/g, "") // enlève caractères spéciaux
    .trim()
    .replace(/\s+/g, "-");

  useEffect(() => {
    fetch_data.GetData("cg/")
      .then(result => {
        if(!result.result)
          return
        var text = result.text;
        setContent(text);
        const lines = text.split("\n");
        const arr = [];
        lines.forEach(line => {
          if(line.startsWith("##") && !line.startsWith("###"))
          {
            let title = line.replace(/^##\s/, "");
            arr.push({'title':title,id:title.toLowerCase().replace(/\s+/g, "-"),subtitles:[]})
          }
          else if(arr.length>0 && line.startsWith("###"))
          {
            let subtitle = line.replace(/^###\s/, "");
            arr[arr.length-1].subtitles.push({'title':subtitle,id:subtitle.toLowerCase().replace(/\s+/g, "-")})
          }
        });
        console.log(arr);
        setHeadings(arr);
      });
  }, []);

  if(content==="")
  {return(<div className="layout"> 
     <DivLoader />
  </div>)}
  else{}
  return (
    <div className="layout" style={{}}>
      <BrowserView style={{width:'30%'}}>
        <nav className="toc" style={{verticalAlign:'middle'}}>
          <h3>Sommaire</h3>
          <ul style={{textAlign:'left'}}>
            {headings.map(h => (
              <li key={h.id} style={{fontWeight:'bold',fontSize:'xx-small'}}>
                <a style={{fontSize:'small'}} href={`#${h.id}`}>{h.title}</a>
                <u style={{fontWeight:'normal',paddingLeft:'10px'}}>
                  {h.subtitles.map((s)=>(
                    <li key={h.id} style={{fontWeight:'normal',paddingLeft:'10px',fontSize:'xx-small'}}>
                      <a style={{fontSize:'x-small'}} href={`#${s.id}`}>{s.title.replace(/\\/g, "")}</a>
                    </li>
                  ))}
                </u>
              </li>
            ))}
          </ul>
        </nav>
      </BrowserView>
      <div className="content">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h2: ({ children }) => {
              const text = children.toString();
              return <h2 id={slugify(text)}>{children}</h2>;
            }
          }}
        >
          {content}
        </ReactMarkdown>
        {display_close_button && (
          <input type="button" value="Fermer" onClick={close} style={{border:'none',borderRadius:'5px',backgroundColor:'rgb(250, 123, 123)',marginTop:'20px',padding:'8px 40px'}} />
        )}
      </div>
    </div>
  );
}